'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const LogoDecathlonStorePinAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 45 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M29.6195 42.4401C38.1192 39.4156 44.2 31.3419 44.2 21.8571C44.2 9.78578 34.3502 0 22.2 0C10.0497 0 0.199951 9.78578 0.199951 21.8571C0.199951 31.4503 6.42065 39.6001 15.0731 42.5419C15.1199 42.6132 15.2564 42.6897 15.4957 42.7714C19.2164 44.0429 22.3435 51 22.3435 51C22.3435 51 25.4705 44.0429 29.1913 42.7714C29.5489 42.6492 29.6769 42.5388 29.6195 42.4401Z",
          fill: "#3643BA"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M26.0394 15C20.5403 15 13.7 20.7774 13.7 25.5655C13.7 28.0385 15.5706 29.2857 18.0414 29.2857C19.8556 29.2857 22.051 28.6119 24.1687 27.3145V17.7597C23.604 18.7417 20.9497 22.6984 18.8179 24.8057C17.7307 25.8809 16.8695 26.3469 16.1283 26.3469C15.2953 26.3469 14.9 25.7734 14.9 24.9204C14.9 21.0497 21.3168 16.0178 25.5665 16.0178C27.3171 16.0178 28.4466 16.8063 28.4466 18.3403C28.4466 19.7452 27.5077 21.5085 25.9053 23.1356V26.096C28.7007 23.8524 30.3738 20.9924 30.3738 18.6843C30.3738 16.2544 28.5101 15 26.0394 15Z",
          fill: "white"
        }
      )
    ]
  }
);
const VpLogoDecathlonStorePinAsset = forwardRef(LogoDecathlonStorePinAsset);

export { VpLogoDecathlonStorePinAsset as default };
